var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MapModal',{staticClass:"newModelPosition hierarchy2",attrs:{"modalNode":_vm.modalNode,"submitData":_vm.submitData,"submit":_vm.submit,"close":_vm.close,"title":_vm.cutTitle,"id":"addTrafficSimulation"}})
}
var staticRenderFns = []

export { render, staticRenderFns }